import { REACT_APP_API_HOST as API_HOST } from 'envs';
import { axiosMockInstance } from './axios-mock-instance';

axiosMockInstance.onGet(API_HOST + '/message').reply(200, {
	msg: 'Awadhesh message recivd',
});
